const isLocalHost = (host = '') => (
  ['localhost', '127.0.0.1', '::1'].includes(host) ||
  host.startsWith('192.168.') ||
  host.startsWith('10.') ||
  /^172\.(1[6-9]|2[0-9]|3[0-1])\./.test(host)
);

const getApiUrl = () => {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  if (typeof window === 'undefined') return 'http://localhost:5000';

  const hostname = window.location.hostname;
  const isLocal = isLocalHost(hostname);

  if (isLocal) {
    return `${window.location.protocol}//${hostname}:5000`;
  }

  return window.location.origin;
};

export const API_URL = getApiUrl();

export default API_URL;
